import React, { useCallback, useEffect, useState } from 'react';

import { obterStatusDaSincronizacao } from '../../../api/previsaoPecas/previsaoPecasApi';
import { StatusCompras } from '../../../api/comprasDashboardApi';
import { CartaoDaCamada } from '../../dashboard_compras/components/PainelSincronizacao';
import { notify } from '../../../shared/feedback/notify';
// O cartão de camada é o do Dashboard de Compras — reaproveitado, não recopiado (catálogo de UI).
import '../../dashboard_compras/pages/DashboardCompras.css';
import '../../../shared/ui/dashboard-base.css';
import '../../../shared/ui/badge-status.css';
import '../../../shared/feedback/erro-de-tela.css';

/**
 * A aba Sincronização (previsao-pecas/at-02): as duas leituras do Nasajon de que esta tela depende,
 * no espelho de compras do SOAC — os PEDIDOS (com os itens) e as ENTREGAS (o elo pedido → nota, a
 * data e os itens de cada nota, que viram a chegada por item).
 *
 * 🔴 Falha de carga nunca vira "ainda não sincronizado": seria mandar alguém investigar uma
 * integração que pode estar funcionando, ou confiar numa tela velha.
 */
const SincronizacaoPrevisao: React.FC = () => {
  const [status, setStatus] = useState<StatusCompras | null>(null);
  const [falhou, setFalhou] = useState(false);

  const carregar = useCallback(async () => {
    try {
      setStatus((await obterStatusDaSincronizacao()) as unknown as StatusCompras);
      setFalhou(false);
    } catch (error) {
      setFalhou(true);
      notify.errorFrom(error, 'Não foi possível consultar a sincronização. Recarregue a página; se persistir, acione a TI.');
    }
  }, []);

  useEffect(() => {
    carregar();
    // A camada de entregas leva minutos: atualizar sozinho evita a pessoa olhar um "em andamento"
    // congelado.
    const id = window.setInterval(carregar, 30_000);
    return () => window.clearInterval(id);
  }, [carregar]);

  if (falhou) {
    return (
      <div className="erro-de-tela" role="alert">
        Não foi possível consultar o estado da sincronização. Isso não quer dizer que ela parou.
      </div>
    );
  }
  if (!status) return <p className="do-nota-janela">Carregando...</p>;

  return (
    <div style={{ display: 'grid', gap: 16, width: '100%' }}>
      <p className="do-nota-janela">
        A chegada das peças vem das notas de entrada do Nasajon: a leitura de <strong>Entregas</strong> traz cada nota
        ligada a um pedido, com a data e as peças dela. Os itens dos pedidos vêm da leitura de{' '}
        <strong>Pedidos de compra</strong>. Sem os dois, a nota fica esperando para ser casada.
      </p>
      {(['ENTREGAS', 'PEDIDOS'] as const).map((camada) =>
        status.camadas[camada] ? (
          <CartaoDaCamada
            key={camada}
            camada={camada}
            estado={status.camadas[camada]}
            janela={status.janelaDeExpediente}
            sincronizacao={status.sincronizacao}
          />
        ) : null,
      )}
    </div>
  );
};

export default SincronizacaoPrevisao;
